import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  PendingInterceptorService,
  PendingInterceptorServiceFactoryProvider,
} from './pending-interceptor.service';

const PendingInterceptorServiceExistingProvider = {
  provide: HTTP_INTERCEPTORS,
  useExisting: PendingInterceptorService,
  multi: true,
};

export const pendingInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useExisting: PendingInterceptorService,
    multi: true,
  },
  PendingInterceptorServiceFactoryProvider,
];
